import React from 'react';

export interface WaitingIndicatorProps {
  message: string;
  isVisible: boolean;
  progress?: number; // 0-100
  showProgress?: boolean;
  className?: string;
}

const WaitingIndicator: React.FC<WaitingIndicatorProps> = ({
  message,
  isVisible,
  progress = 0,
  showProgress = false,
  className = ''
}) => {
  if (!isVisible) return null;

  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-center space-x-3">
        {/* Animated dots */}
        <div className="flex space-x-1">
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
        
        {/* Message */}
        <div className="flex-1">
          <p className="text-sm font-medium text-blue-900">{message}</p>
          
          {/* Progress bar */}
          {showProgress && (
            <div className="mt-2">
              <div className="w-full bg-blue-200 rounded-full h-2">
                <div
                  className="bg-blue-600 h-2 rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
                ></div>
              </div>
              <p className="text-xs text-blue-700 mt-1">{Math.round(progress)}% complete</p>
            </div>
          )}
        </div>
        
        {/* Icon */}
        <div className="text-blue-500">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default WaitingIndicator;
